{
	"pixKeyLabel": "Clave PIX",
	"pixTypeLabel": "Tipo de Clave PIX",
	"pixTypePlaceholder": "Seleccione el tipo de Clave PIX",
	"defaultPlaceholder": "Ingrese clave PIX",
	"copyPastePlaceholder": "Pegue su clave PIX",
	"placeholders": {
		"phone": "(41) 99999-9999",
		"cpf": "000.000.000-00",
		"cnpj": "00.000.000/0000-00",
		"email": "ejemplo@email.com",
		"evp": "Clave aleatoria"
	},
	"pixKeyType": {
		"random": "Aleatoria",
		"phone": "Teléfono",
		"copyPaste": "Copiar y Pegar"
	},
	"validation": {
		"invalidPixKey": "Clave PIX inválida"
	}
}
